var map = {
	"./MacBook_Pro_sito_ferrari.png": 2458,
	"./check_in_cover.png": 945,
	"./dbMng_cover.png": 3066,
	"./dedicated_team_cover_2.jpeg": 4955,
	"./iPad_Mockup_prova.png": 5690,
	"./ipad_dashboard.png": 3871,
	"./multi_lang.png": 5041,
	"./people.png": 4462,
	"./people_pic.png": 3918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1188;